import Config from "../../config";
import UserTopbarSection from "./user-topbar-section";
import MainMenu from "./main-menu";

export default function Header() {
	return <header class="website-header bg-blue-whale-900 text-white">
	    <UserTopbarSection />
		<div class="flex bg-blue-whale-800 text-white items-stretch">
		    <div class="w-32 grow">
				<a class="header-logo inline-block pt-2 px-4" href="/">
			        <img src={Config.logourl} alt={Config.title} style="max-width: 244px; height: 45px" />
			    </a>
			</div>
		    <MainMenu />
			<div class="w-32 grow"></div>
		</div>
	</header>;
}
